var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoCallCircle50(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "18px",
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoCallCircle50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--Callback",
    transform: "translate(-890.000000, -648.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M915.411765,651.2804 L915.411765,662.708346 C915.411765,663.591747 914.527063,664.14317 913.819301,663.704283 L909.416607,660.958425 L909.416607,661.740544 C909.416607,664.092529 907.652408,666 905.477081,666 L893.939526,666 C891.7642,666 890,664.092529 890,661.740544 L890,652.259456 C890,649.907471 891.7642,648 893.939526,648 L905.482285,648 C907.657612,648 909.421812,649.907471 909.421812,652.259456 L909.421812,653.041575 L913.824505,650.295717 C914.527063,649.845577 915.411765,650.402626 915.411765,651.2804 Z",
    id: "icVideoCallCircle50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCallCircle50);
export default __webpack_public_path__ + "static/media/icVideoCallCircle50.8e5a7f479bfd33bb73b0b549ea6b4a69.svg";
export { ForwardRef as ReactComponent };